<template>
    <div>
        <button
            type="button"
            class="btn-circle pl-xs"
            @click="$modal.show(modalName)"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="15"
                viewBox="0 0 22 15"
                class="fill-current"
            >
                <path d="M14.496.392c.416 0 .77.147 1.064.44.293.293.44.648.44 1.064v2.436L14 6.32V4.392H9.008V7.4h3.906l-2.012 2H9.008v1.883L9 11.291v3.117H1.504c-.364 0-.681-.112-.951-.337l-.113-.103C.147 13.675 0 13.32 0 12.904V1.896c0-.416.147-.77.44-1.064.293-.293.648-.44 1.064-.44zM7.008 9.4H2v2.992h5.008V9.4zm0-5.008H2V7.4h5.008V4.392z" />
                <path d="M19.654 7.826l1.244-1.244c.201-.201.302-.448.302-.739s-.1-.537-.302-.739l-1.322-1.322c-.202-.201-.448-.302-.74-.302-.29 0-.537.1-.738.302l-1.244 1.244 2.8 2.8zm-9.167 6.855l.095-.001 2.498-.28 6.082-6.082-2.8-2.8L10.28 11.6 10 14.098c-.015.164.037.306.157.425.12.12.261.172.425.157h-.095z" />
            </svg>
        </button>
        <adaptive-modal
            :name="modalName"
            primary-button-text="Spara"
            primary-button-class="is-primary"
            :show-hide-button="false"
            :hide-action-buttons="true"
        >
            <div class="flex justify-between items-center mb-2xl">
                <h1 class="m-0 text-md">
                    Visa/dölj kolumner
                </h1>
                <button
                    type="button"
                    class="btn is-ghost btn-sm"
                    @click="resetColumns"
                >
                    Ändra tillbaka till standard
                </button>
            </div>
            <div>
                <toggle-table-column
                    v-for="column in allColumns"
                    :key="`toggle-table-column-${column.value}`"
                    :column="column"
                    :store-name="storeName"
                    :selected-columns="selectedColumns"
                />
            </div>
            <div class="flex mt-2xl justify-end">
                <slot name="primary-action">
                    <button
                        type="button"
                        class="btn btn-lg is-primary mb-md md:mb-0"
                        @click="$modal.hide(modalName)"
                    >
                        Stäng
                    </button>
                </slot>
            </div>
        </adaptive-modal>
    </div>
</template>

<script>
    import ToggleTableColumn from './ToggleTableColumn';

    export default {
        components: {
            ToggleTableColumn,
        },
        props: {
            storeName: {
                type: String,
                required: true,
            },
        },
        computed: {
            selectedColumns() {
                return this.$store.getters[`${this.storeName}/selectedColumns`];
            },
            allColumns() {
                return this.$store.getters[`${this.storeName}/allColumns`];
            },
            modalName() {
                return `${this.storeName}-toggle-columns-modal`;
            },
        },
        created() {
            this.$store.dispatch(`${this.storeName}/setDefaultColumns`);
        },
        methods: {
            resetColumns() {
                this.$store.dispatch(`${this.storeName}/resetColumns`);
            },
        },
    };
</script>
